"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cheerio_utils_1 = require("./cheerio-utils");
var findQuoteString_1 = __importDefault(require("./findQuoteString"));
/**
 * Remove quotations (replied messages) and signatures from the HTML
 */
function removeQuotations($) {
    var didFindQuotation = false;
    // Remove blockquote elements
    var quoteElements = findAllQuotes($);
    didFindQuotation = didFindQuotation || quoteElements.length > 0;
    quoteElements.each(function (i, el) { return $(el).remove(); });
    // When all blockquotes are removed, remove any remaining quote header text
    var remainingQuoteNodes = findQuoteString_1.default($);
    didFindQuotation = didFindQuotation || remainingQuoteNodes.length > 0;
    remainingQuoteNodes.forEach(function (el) { return $(el).remove(); });
    return { didFindQuotation: didFindQuotation };
}
/**
 * Returns a selection of all quote elements that should be removed
 */
function findAllQuotes($) {
    var quoteElements = $([
        '.gmail_quote',
        'blockquote',
        // Signatures.
        '.gmail_signature',
        'signature',
        // ENHANCEMENT: Add findQuotesAfterMessageHeaderBlock
        // ENHANCEMENT: Add findQuotesAfter__OriginalMessage__
    ].join(', '));
    // Ignore inline quotes. Quotes that are followed by non-quote blocks.
    var quoteElementsSet = new Set(cheerio_utils_1.toArray(quoteElements));
    var withoutInlineQuotes = quoteElements.filter(function (i, el) { return !isInlineQuote(el, quoteElementsSet); });
    return withoutInlineQuotes;
}
/**
 * Returns true if the element looks like an inline quote:
 * it is followed by unquoted elements
 *
 * Works best if non-meaningful content were stripped before, like tracking pixels.
 *
 * Based on
 * https://github.com/Foundry376/Mailspring/blob/aa125f0136c093e0aa3deb7c46bb6433f6ede6b9/app/src/services/quoted-html-transformer.ts#L228:L228
 */
function isInlineQuote(el, quoteSet) {
    var seen = new Set();
    var head = el;
    while (head) {
        // advance to the next sibling, or the parent's next sibling
        while (head && !head.nextSibling) {
            head = head.parentNode;
        }
        if (!head) {
            break;
        }
        head = head.nextSibling;
        // search this branch of the tree for any text nodes / images that
        // are not contained within a matched quoted text block. We mark
        // the subtree as "seen" because we traverse upwards, and would
        // re-evaluate the subtree on each iteration otherwise.
        var pile = [head];
        var node = null;
        while ((node = pile.pop())) {
            if (seen.has(node)) {
                continue;
            }
            if (quoteSet.has(node)) {
                continue;
            }
            if (node.childNodes) {
                pile.push.apply(pile, __spreadArray([], __read(node.childNodes)));
            }
            if (cheerio_utils_1.isImage(node)) {
                return true;
            }
            if (cheerio_utils_1.isText(node) && !cheerio_utils_1.isEmptyish(node)) {
                return true;
            }
        }
        seen.add(head);
    }
    return false;
}
exports.default = removeQuotations;
